import gql from 'graphql-tag';

const ListArticleFragment = gql`
  fragment ListArticleFragment on Article {
    _id
    title
    date
    image
    source
    featured
  }
`;

export const ListArticlesQuery = gql`
  query($filter: JSON) {
    Articles(filter: $filter) {
      ...ListArticleFragment
    }
  }
  ${ListArticleFragment}
`;

export const ArticleLinksQuery = gql`
  {
    Articles {
      link
    }
  }
`;

export const ArticleDetailsQuery = gql`
  query($id: String!) {
    Article(filter:{_id: $id}) {
      _id
      title
      content
      date
      image
      link
      source
      featured
      tag {
        _id
      }
      sneakerModel {
        _id
      }
    }
    ModelTags {
      _id
      title
    }
    SneakerModels(filter: { isDeleted: null }) {
      _id
      name
      isDeleted
    }
  }
`;

export const CreateArticleFormOptionsQuery = gql`
  {
    ModelTags {
      _id
      title
    }
    SneakerModels(filter: { isDeleted: null }) {
      _id
      name
      isDeleted
    }
  }
`;

export const CreateArticleMutation = gql`
  mutation($record: JSON) {
    createArticle(record: $record) {
      _id
    }
  }
`;

export const UpdateArticleMutation = gql`
  mutation($id: String!, $update: JSON) {
    updateArticle(filter: {_id: $id}, update: $update) {
      ...ListArticleFragment
    }
  }
  ${ListArticleFragment}
`;

export const DeleteArticleMutation = gql`
  mutation($id: String!) {
    deleteArticle(query: {_id: $id})
  }
`;
